import React from "react";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";

const CohabitantDetails = (props) => {
  // console.log(props);

  const cohabDetails = {
    date_of_birth: props.date_of_birth,
    first_name: props.first_name,
    id: props.id,
    last_name: props.last_name,
    relation: props.relation,
  };

  let dob = new Date(props.date_of_birth);

  let month_diff = Date.now() - dob.getTime();

  let age_dt = new Date(month_diff);

  let year = age_dt.getUTCFullYear();

  let age = Math.abs(year - 1970);

  return (
    <tbody className="border-dark">
      <tr>
        <td className="text-center align-middle">{props.first_name}</td>
        <td className="text-center align-middle">{props.last_name}</td>
        <td className="text-center align-middle">{age}</td>
        <td className="text-center align-middle">{props.date_of_birth}</td>
        <td className="text-center align-middle">{props.relation}</td>
        {props.currentUser?.admin ? (
          <>
            <td>
              <Link
                to={`/cohabitants/${props.id}/edit`}
                state={{ fromCohabitantDetails: cohabDetails }}
                className="btn btn-success d-block"
              >
                Edit Cohabitant
              </Link>
            </td>
            <td>
              <Button
                className={"d-block mx-auto w-100"}
                variant="outline-danger"
                onClick={() => props.deleteCohabitant(props.id)}
              >
                Delete Cohabitant
              </Button>
            </td>
          </>
        ) : (
          ""
        )}
      </tr>
    </tbody>
  );
};

export default CohabitantDetails;
